export function gtmDataLayer() {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push(arguments)

  return false
}
